import { createReducer, on } from "@ngrx/store";
import { initialAuthState } from "./user.state";
import { UserActions } from './user.actions'
import { onLoadableLoad, onLoadableSuccess, onLoadableError, createDefaultLoadable } from '../../models/index';

export const userReducer = createReducer(
    initialAuthState,
    on(UserActions.login, state => ({ ...onLoadableLoad(state) })),
    on(UserActions.setToken, (state, { token }) => ({ ...state, authToken: token })),
    on(UserActions.fetchUser, (state) => ({ ...onLoadableLoad(state) })),
    on(UserActions.fetchUserSuccess, (state, { user }) => ({ ...onLoadableSuccess(state), user: user })),
    on(UserActions.fetchUserFailure, (state, { error }) => ({ ...onLoadableError(state, error) })),
    on(UserActions.logout, _ => ({ ...initialAuthState })),
    on(UserActions.getMediaMTXTokenSuccess, (state, { mediaMTXToken }) => ({
        ...state,
        mediaMTXToken: mediaMTXToken
    })),
    on(UserActions.getCode, state => ({
        ...state,
        code: {
            ...onLoadableLoad(state.code),
        }
    })),

    //Code Retrieval
    on(UserActions.getCodeSuccess, (state, { code }) => ({
        ...state,
        code: {
            ...onLoadableSuccess(state.code),
            code: code
        }
    })),
    on(UserActions.getCodeFailure, (state, { error }) => ({
        ...state,
        code: {
            ...onLoadableError(state.code, error),
        }
    })),
    //Code Verification
    on(UserActions.verifyCode, (state, { code }) => ({
        ...state,
        code: {
            ...onLoadableLoad(state.code),
        }
    })),
    on(UserActions.verifyCodeSuccess, (state) => ({
        ...state,
        code: {
            ...onLoadableSuccess(state.code),
        }
    })),
    on(UserActions.verifyCodeFailure, (state, { error }) => ({
        ...state,
        code: {
            ...onLoadableError(state.code, error),
        }
    })),
    on(UserActions.unlockAdmin, (state) => ({
        ...state,
        adminUnlocked: true
    })),
    on(UserActions.lockAdmin, (state) => ({
        ...state,
        adminUnlocked: false
    })),
    on(UserActions.clearCode, (state) => ({
        ...state,
        code: {
            ...state.code,
            ...createDefaultLoadable()
        }
    })),
)
